<script setup lang="ts">
  import { reactiveOmit } from '@vueuse/core';
  import type { TagsInputItemProps } from 'reka-ui';
  import { injectTagsInputRootContext, TagsInputItem, useForwardProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  const props = defineProps<TagsInputItemProps & { class?: HTMLAttributes['class'] }>();

  const delegatedProps = reactiveOmit(props, 'class');

  const forwardedProps = useForwardProps(delegatedProps);

  const rootContext = injectTagsInputRootContext();

  function onItemClick(event: MouseEvent) {
    if (rootContext.disabled.value) return;
    const target = event.target as HTMLElement | null;
    if (target?.closest('button')) return;

    const tagEl = event.currentTarget as HTMLElement;
    rootContext.selectedElement.value = tagEl;

    const root = tagEl.closest('[data-slot="tags-input"]') as HTMLElement | null;
    const inputEl = root?.querySelector<HTMLInputElement>('input:not([type="hidden"])');
    inputEl?.focus();
    inputEl?.setSelectionRange(0, 0);
  }
</script>

<template>
  <TagsInputItem
    v-bind="forwardedProps"
    :class="
      cn(
        'flex h-6.5 items-center rounded-sm bg-secondary data-[state=active]:ring-primary data-[state=active]:ring-2 data-[state=active]:ring-offset-2 ring-offset-background cursor-pointer',
        props.class,
      )
    "
    @click="onItemClick"
  >
    <slot />
  </TagsInputItem>
</template>
